export enum ClientType {
    NATURAL_PERSON = 'NaturalPerson',
    LEGAL_PERSON = 'LegalPerson',
    MINOR = 'Minor',
    DISABLED = 'Disabled',
}
